import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useServicesContext } from '@miro-site/services';
import { Box, Button, Play, appendWistiaScript, appendWistiaJsonpScript } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = styled(Box).withConfig({
  displayName: "VideoPopoverButton__Wrapper",
  componentId: "sc-1ucxeey-0"
})(["text-align:left;position:relative;margin-bottom:24px;"]);
var IconWrapper = styled(Box).withConfig({
  displayName: "VideoPopoverButton__IconWrapper",
  componentId: "sc-1ucxeey-1"
})(["height:14px;width:14px;display:inline-block;fill:black;background-color:#4262ff;border-radius:50%;transform:translateY(2px);margin-right:8px;"]);

// https://wistia.com/support/developers/player-api#use-window-_wq-to-get-a-video-handle
var getWistiaApi = function getWistiaApi(videoId, callback) {
  window._wq = window._wq || [];

  window._wq.push({
    id: videoId,
    onReady: function onReady(video) {
      return callback(video);
    }
  });
};

var VideoPopoverButton = function VideoPopoverButton(_ref) {
  var id = _ref.id;

  var _useServicesContext = useServicesContext(),
      eventHub = _useServicesContext.eventHub;

  useEffect(function () {
    appendWistiaScript();
    appendWistiaJsonpScript(id);
  }, [id]);
  useEffect(function () {
    getWistiaApi(id, function (video) {
      video.bind('popovershow', function () {
        eventHub === null || eventHub === void 0 ? void 0 : eventHub.track('lp-demo-video-popovershow');
      });
      video.bind('popoverhide', function () {
        eventHub === null || eventHub === void 0 ? void 0 : eventHub.track('lp-demo-video-popoverhide');
      });
    });
    return function () {
      getWistiaApi(id, function (video) {
        video.unbind('popovershow');
        video.unbind('popoverhide');
      });
    };
  }, [id]);

  var handleOnClick = function handleOnClick() {
    getWistiaApi(id, function (video) {
      return video.play();
    });
  };

  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsxs(Button, {
      $buttonType: "secondary",
      $size: "small",
      onClick: handleOnClick,
      children: [/*#__PURE__*/_jsx(IconWrapper, {
        children: /*#__PURE__*/_jsx(Play, {
          viewBox: "-12 -8 28 28"
        })
      }), "Watch a 1-min Miro overview"]
    }), /*#__PURE__*/_jsx("span", {
      className: "wistia_embed wistia_async_".concat(id, " popover=true popoverContent=link")
    })]
  });
};

export default VideoPopoverButton;